import { type UseQueryResult, useQuery } from 'react-query';
import { ParticipantTotalNetWorthService } from '../../services/wealthlane-customer-services';

const useGetParticipantTotalNetWorth = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const ParticipantTotalNetWorthList = useQuery(
    ['getParticipantTotalNetWorthList'],
    async () => {
      return await handleRequest(
        ParticipantTotalNetWorthService.getApiCustomerApiAppParticipantTotalNetWorthParticipantTotalNetWorthsList()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return ParticipantTotalNetWorthList;
};
export default useGetParticipantTotalNetWorth;
